"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _default = {
  SubpageOverlayContainer: _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: fixed;\n    transform: scale3d(1, 1, 1);\n    height: 100%;\n    top: 0;\n    left: 0;\n    width: 100%;\n    opacity: 1;\n    z-index: 1;\n    transition: opacity 0.3s;\n  "]))),
  SubpageOverlayBackground: _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    text-indent: -9999px;\n    display: block;\n    background: rgba(0, 0, 0, 0.8);\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    padding: 0;\n    margin: 0;\n    border: none;\n  "]))),
  SubpageOverlay: _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    position: absolute;\n    background: ", ";\n    transform: scale3d(1, 1, 1);\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_ref) {
    var background = _ref.background;
    return background || '#FFF';
  }, function (_ref2) {
    var fit = _ref2.fit;
    return fit !== 'child' ? "\n      width: 100%;\n      height: 100%;\n    " : "\n      max-height: 90%;\n    ";
  }, function (_ref3) {
    var fit = _ref3.fit;
    return fit === 'lightbox' && "\n      max-width: 620px;\n      width: calc(100% - 50px);\n      height: 80%;\n    ";
  }, function (_ref4) {
    var fit = _ref4.fit;
    return fit === 'cover' ? "\n      top: 0;\n      left: 0;\n      transform: scale3d(1, 1, 1);\n    " : "\n      left: 50%;\n      top: 50%;\n      transform: translate3d(-50%, -50%, 0) scale3d(1, 1, 1);\n    ";
  }),
  PageContent: _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n    position: relative;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    box-sizing: border-box;\n  "]))),
  ChildrenWrapper: _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref5) {
    var pageSpacing = _ref5.pageSpacing;
    return pageSpacing && "padding-top: 65px;";
  }),
  CloseButton: _styledComponents.default.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    height: 60px;\n    width: 60px;\n    cursor: pointer;\n    background: rgba(0, 0, 0, 0.8);\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    svg {\n      width: 20px;\n      top: 50%;\n      left: 50%;\n    }\n    ", "\n  "])), function (_ref6) {
    var theme = _ref6.theme;
    return theme === 'light' && "\n      background: transparent;\n      svg {\n        fill: #000;\n      }\n    ";
  })
};
exports.default = _default;